import { CardBrand } from '@afterpay/types'

export enum PaymentIconsDirection {
  Horizontal = 'Horizontal',
  Vertical = 'Vertical',
}

export const DEFAULT_ALLOWED_CARD_BRAND = [CardBrand.MASTERCARD, CardBrand.VISA, CardBrand.AMEX, CardBrand.DISCOVER]
